import React from 'react';
import Navigation from '../../Shared/Navigation/Navigation';
import Addservice from '../AddService/Addservice';

const TogetherAdd = () => {
    return (
        <div>
            
            <Addservice></Addservice>
           
        </div>
    );
};

export default TogetherAdd;